import './main.less';
import Suggest from './suggest';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import isEqual from 'lodash/isEqual';

import CustomizableBlock from '../customizable-block';

const propTypes = {
	langs: PropTypes.array,
	onChangeLang: PropTypes.func
};

class LangSwitch extends  React.Component {
	constructor(props) {
		super(props);
		this.state = {
			langs: this.props.langs,
			isOpen: false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (!isEqual(nextProps.langs, this.state.langs)) {
			this.setState({
				langs: nextProps.langs
			});
		}
	}

	onOpenLanguagesList() {
		this.setState({
			isOpen: true
		});
	}

	handleClickOutside(e) {
		this.setState({
			isOpen: false
		});
	}

	onToggleSelectLanguage(id) {
		const langs = this.state.langs.map(lang => {
			if (lang.id === id) {
				lang.isSelected = !lang.isSelected;
			}
			return lang;
		});

		this.setState({
			langs
		});
	}

	onSetActive(id) {
		const langs = this.state.langs.map(lang => {
			lang.isActive = lang.id === id;
			return lang;
		});

		this.setState(
			() => ({ langs }),
			() => this.props.onChangeLang(id)
		);
	}

	render() {
		const langs = this.state.langs.filter((lang) => lang.isSelected);
		return (
			<div className="lang-switch clearfix">
				<CustomizableBlock className="lang__lists" settingId='languages'>
					{(isExtraLangs) => langs.filter((lang) => !isExtraLangs ? ['en', 'ru'].includes(lang.id) : true).map(lang => (
						<div
							className={cn({
								'item': true,
								'active': lang.isActive
							})}
							key={lang.id}
							onClick={this.onSetActive.bind(this, lang.id)}>
							<span className={`item-flag flag-icon flag-icon-${lang.id}`} />
							<span className="item-title">{lang.text}</span>
						</div>
					))}
				</CustomizableBlock>
				<div className="lang__control">
					{false && (
						<span
							className="lang__control-add"
							onClick={this.onOpenLanguagesList.bind(this)}>Добавить язык</span>
					)}
					{ this.state.isOpen && (
						<Suggest
							langs={this.state.langs}
							onToggleLanguage={this.onToggleSelectLanguage.bind(this)}
							onClickOutside={this.handleClickOutside.bind(this)} />
					)}
				</div>
			</div>
		);
	}
}

LangSwitch.propTypes = propTypes;

export default LangSwitch;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/lang/switch.js